import React from 'react';
import MaterialTable, {MTableToolbar} from 'material-table';
import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import tableicons from "../tableicons"
import {Modal} from "@material-ui/core";
import AgregarEditarRango from "./AgregarEditarRango";
import DialogEliminar from "./DialogEliminar";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

class TablaRangos extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            openEditar:false,
            eliminar:false,
            rango:{},
            idRango:null,
            cargando: true,
            selectedRow: null,
            openAgregar:false
        }
    }
    handleClose = () =>{
        this.setState({
            openEditar: false,
            eliminar:false,
            content:"",
            title:"",
            rango:{},
            idRango:null,
            openAgregar:false
        })
    }
    editarRango (row){
        this.setState({openEditar: true, rango:row})
    };
    eliminarRango(row){
        this.setState({eliminar:true, title: "Eliminar rango de tags", content: "Esta acción es irreversible. Está seguro que desea eliminar el rango de tags?", idRango:row.id})
    }

    refrescarDatos =(estado,severity)=>{
        this.props.refrescar(estado,severity)
    }
    getEventType = (event) =>{
        if(event.keyCode === 27){
            this.setState({openEditar:false})
        }
    }

    componentDidMount(){
        document.addEventListener('keyup', this.getEventType, false);    // third
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        this.setState({cargando:false})
    }

    render() {
        return (
            <div>
                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar'
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    isLoading={this.state.cargando}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                               backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    icons={tableicons}
                    title="Rangos"
                    data={this.props.datos}
                    columns={[
                        { title: 'Tag inicial', field: 'inicial' },
                        { title: 'Tag final', field: 'final' },
                        { title: 'Comentarios', field: 'comentario' },
                        { title: 'Ubicación', field: 'des_ubicacion'}
                    ]}
                    actions={[
                        {
                            icon:  () => <CreateIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Editar rango',
                            onClick: (event, rowData) => this.editarRango(rowData)
                        },
                        {
                            icon:  () => <DeleteIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Eliminar rango',
                            onClick: (event, rowData) => this.eliminarRango(rowData)
                        },
                    ]}
                    components={{
                        Toolbar: props => (
                            <div>
                                <MTableToolbar {...props} />
                                <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                                    <Grid item>
                                        <Button variant="contained" style={{margin:5}} color={'primary'} onClick={() => this.setState({openAgregar:true}) }>Agregar rango</Button>
                                    </Grid>
                                </Grid>
                            </div>
                        ),
                    }}
                   // onRowClick={(evt, selectedRow) => this.setState({ selectedRow })}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                />
                <Modal
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'}}
                    disableAutoFocus={true}
                    open={this.state.openEditar}>
                    <AgregarEditarRango refrescar={this.refrescarDatos} editar={true} handleClose={this.handleClose} width={'100%'} title={"Editar rango"} rango={this.state.rango}/>
                </Modal>

                <Modal
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'}}
                    disableAutoFocus={true}
                    open={this.state.openAgregar}>
                    <AgregarEditarRango width={'100%'} editar={false}  handleClose={this.handleClose} refrescar={this.refrescarDatos} title={"Agregar rango"}/>
                </Modal>
                {this.state.eliminar? <DialogEliminar origen={"Rangos"} refrescar={this.refrescarDatos} id={this.state.idRango} handleClose={this.handleClose} content={this.state.content} title={this.state.title}  />:null}
            </div>
        )
    }
}
export default TablaRangos;